module.exports = __webpack_public_path__ + "static/media/star.2c10704d.svg";